import { render, staticRenderFns } from "./suggestionStats.vue?vue&type=template&id=4c075630&scoped=true&"
import script from "./suggestionStats.vue?vue&type=script&lang=js&"
export * from "./suggestionStats.vue?vue&type=script&lang=js&"
import style0 from "./suggestionStats.vue?vue&type=style&index=0&id=4c075630&prod&scoped=true&lang=css&"
import style1 from "./suggestionStats.vue?vue&type=style&index=1&id=4c075630&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c075630",
  null
  
)

export default component.exports